import React from 'react'

import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import {
  LicenseActionsCell,
  LicenseButton,
  LicensesTable,
  ReassignLicenseButton,
} from './component.styles'
import { displayAdmins, displayDate } from 'lib/util'

const Licenses = ({
  licenses,
  onSelectAssign,
  onSelectLicense,
  onSelectUserManagement,
  currentUser,
}) => {
  const updatedLicenses = licenses.map(license => {
    const programCodes = license?.product?.programCodes || []
    const programCodesStr =
      programCodes.length > 0 ? programCodes.join('-') : 'unknown'
    return {
      ...license,
      dataTestId: `assigned-license-licenseId-${license.nsId ||
        license.nsName ||
        license.id}-programCodes-${programCodesStr}`,
    }
  })

  const columns = [
    {
      title: 'School',
      fieldValue: row => row?.site?.name || '-',
    },
    {
      title: 'Product',
      fieldValue: row => row.product?.description || '-',
    },
    {
      title: 'License ID',
      fieldValue: row => row.nsName || '-',
    },
    {
      title: 'Contract Line Id',
      fieldValue: row => row.contractLineNSId || '-',
      cellClassName: 'text-center',
    },
    {
      title: 'Expiration Date',
      fieldValue: row => displayDate(row.expirationDate),
      sortValue: 'expirationDate',
    },
    {
      title: 'Administrators',
      fieldValue: row => displayAdmins(row?.site, currentUser.email) || '-',
    },
    {
      title: '',
      fieldValue: row => {
        const isAdmin =
          row?.site?.admins?.length > 0 &&
          row?.site?.admins?.some(
            admin =>
              admin.email.toLowerCase() === currentUser.email.toLowerCase(),
          )

        const isSetupAdmin =
          row?.adminEmail?.toLowerCase() === currentUser.email?.toLowerCase()

        if (!isAdmin && !isSetupAdmin) {
          return null
        }

        return (
          <LicenseActionsCell $stacked={isAdmin && isSetupAdmin}>
            {isAdmin && (
              <LicenseButton
                dataTestId="button-manage-users"
                hasUsers={row.hasUsers}
                onClick={() => onSelectUserManagement(row.site?.id)}
              >
                {row.site?.hasUsers ? 'Manage Users' : 'Add Users'}
              </LicenseButton>
            )}
            {isSetupAdmin && (
              <ReassignLicenseButton
                dataTestId={`button-reassign-license-${row.nsId ||
                  row.nsName ||
                  row.id}`}
                onClick={() => {
                  onSelectLicense(row)
                  onSelectAssign()
                }}
              >
                Reassign License
              </ReassignLicenseButton>
            )}
          </LicenseActionsCell>
        )
      },
      sort: false,
      filter: false,
      cellClassName: 'text-center',
    },
  ]

  return (
    <LicensesTable
      columns={columns}
      filter={false}
      headThemeLight
      key="assigned-users-autotable"
      rows={updatedLicenses}
      sort
    />
  )
}

Licenses.propTypes = {
  currentUser: PropTypes.object.isRequired,
  licenses: PropTypes.arrayOf(PropTypes.object).isRequired,
  onSelectAssign: PropTypes.func.isRequired,
  onSelectLicense: PropTypes.func.isRequired,
  onSelectUserManagement: PropTypes.func,
}

const mapStateToProps = ({ userProfileManager }) => {
  return {
    currentUser: userProfileManager.profile,
  }
}

export default connect(mapStateToProps)(Licenses)
